import { useContext, useEffect, useRef } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';

const useLogoutListener = () => {
  const { logOutFlag, triggerEvent } = useContext(GlobalContext);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      window.location.reload();
    }
  }, [logOutFlag]);

  useEffect(() => {
    const listener = (ev: MouseEvent) => {
      const target = ev.target as HTMLElement;
      if (
        target.matches('a[data-qa="menu-button-wrapper"]') &&
        target.textContent?.toLowerCase() === 'sign out'
      ) {
        triggerEvent.logOut();
      }
    };

    document.addEventListener('click', listener);

    return () => document.removeEventListener('click', listener);
  }, [triggerEvent]);
};

export default useLogoutListener;
